// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oDgvO","pasteButton":"styles_pasteButton__oxHcd","inputContainer":"styles_inputContainer__VB77r","percentage":"styles_percentage__Ut8cH"};